// extracted by mini-css-extract-plugin
export default {"PagePost":"PagePost_PagePost__sqqHg","PagePostContent":"PagePost_PagePostContent__42p6p"};